import { render } from "./setPeppol.vue?vue&type=template&id=35c71bc5"
import script from "./setPeppol.vue?vue&type=script&lang=js"
export * from "./setPeppol.vue?vue&type=script&lang=js"

import "./setPeppol.vue?vue&type=style&index=0&id=35c71bc5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__